import { render, staticRenderFns } from "./ANxACxCriminalPage.vue?vue&type=template&id=0cbd4f1c"
import script from "./ANxACxCriminalPage.vue?vue&type=script&lang=js"
export * from "./ANxACxCriminalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports